import { productCategories } from "@/data/productCategories";
import { routes } from "@/data/routes";
import { CreditCardIcon, HelpCircleIcon, ShieldCheckIcon, TruckIcon } from "lucide-react";

const homeData = {
  spotlight: {
    mobileImage: "/spotlight-mobile.jpeg",
    desktopImage: "/spotlight.jpg",
  },
  categories: {
    title: "Explore our collections",
    carousel: [...productCategories, ...productCategories].map((category) => ({
      ...category,
      path: routes.products.path + category.path,
    })),
  },
  sections: [
    {
      title: {
        firstPart: "Collection",
        secondPart: "Cozy",
      },
      image: "/home-1.jpg",
      path: routes.products.path + "?category=baths",
      type: "full",
    },
    {
      title: {
        firstPart: "Find your perfect",
        secondPart: "Waterfall",
      },
      image: "/home-2.jpg",
      path: routes.products.path + "?category=showers",
      type: "split",
    },
    {
      title: {
        firstPart: "Collection",
        secondPart: "Comfy",
      },
      image: "/home-3.jpg",
      path: routes.products.path + "?category=baths",
      type: "full",
    },
    {
      title: {
        firstPart: "Discover your",
        secondPart: "Tiles",
      },
      image: "/home-4.jpg",
      path: routes.products.path + "?category=tiles",
      type: "split-reverse",
    },
  ],
  quote: {
    text: "Inspiration begins where you are right now...",
  },
  services: [
    {
      title: "Free Delivery",
      icon: TruckIcon,
    },
    {
      title: "Secure Payment",
      icon: CreditCardIcon,
    },
    {
      title: "Best Quality",
      icon: ShieldCheckIcon,
    },
    {
      title: "24/7 Support",
      icon: HelpCircleIcon,
    },
  ],
};

export default homeData;
